import { useNavigate, useParams } from "react-router-dom";
import "bulma/css/bulma.min.css";
import { Block, Box, Button, Container, Section } from "react-bulma-components";
import Nav from "../components/Nav";
import SiteFooter from "../components/Footer";

function JobApply() {
  const { id } = useParams();

  let navigate = useNavigate();

  const onDoneClicked = id => async () => {
    navigate(`/jobs/${id}`, {
      state: { status: "success" },
    });
  };

  return (
    <div>
      <Nav />
      <div className="d-flex min-vh-100 hero-text wow slideUp">
        <Container>
          <Section>
            <Container>
              <Box>
                <h2 className="mb-4">Complete Your Application</h2>
                <Block>
                  <iframe
                    src="https://zenople.esgazure.com/apply/MEB"
                    title="Complete Your Application"
                    width="100%"
                    height="680px"
                    style={{ border: "none" }}
                  ></iframe>
                </Block>
                <Block>
                  <Button
                    color="info"
                    size="medium"
                    rounded
                    fullwidth
                    onClick={onDoneClicked(id)}
                  >
                    Done
                  </Button>
                </Block>
              </Box>
            </Container>
          </Section>
        </Container>
      </div>
      <script>new WOW().init();</script>
      <SiteFooter />
    </div>
  );
}

export default JobApply;
